import { View, Text } from "react-native";
import { Button } from "ui/gluestack/button";
import { Icon } from "ui/gluestack/icon";

type Props = {
  icon: React.ComponentType;
  label: string;
  onPress?: () => void;
  selected?: boolean;
};

export function WaterIntakeButton({ icon, label, onPress, selected }: Props) {
  return (
    <Button
      onPress={onPress}
      variant="outline"
      className={`border-secondary-300 p-6 w-28 h-32 ${selected ? "bg-gray-50 border-primary-400" : null}`}
    >
      <View className="flex-column items-center gap-2">
        <Icon as={icon} className="w-16 h-16 text-secondary-400" />
        <Text className="font-medium text-xs flex-shrink">{label}</Text>
      </View>
    </Button>
  );
}
